import { useEffect, useState } from "react";
import { Table } from "../../../../components/table";
import { H3, Label, P } from "../../../../components/typography/styled";
import { Layout } from "../../../../containers/app/layout";
import { SummaryWrapper } from "./styled";
import Cookies from "universal-cookie";
import { BaseFieldSet } from "../../../../components/form/fieldset/styled";
import { BaseSelect } from "../../../../components/form/select/styled";
import { months } from "../../../../helpers/retrieveAllMonths";
import { getYearRange } from "../../../../helpers/retrieveAllYearsToDate";
import { retrievePayrollByDate } from "../../../../utils/apis/payroll/retrievePayrollByDate";

export const Summary = () => {
  const startDate = 2020;
  const endDate = new Date().getFullYear();

  const cookies = new Cookies();
  const TOKEN = cookies.get("TOKEN");
  const COMPANY_ID = cookies.get("COMPANY_ID");
  const currentDate = new Date();
  const currentMonth = currentDate.getMonth() + 1;
  const currentYear = currentDate.getFullYear();

  const [payslips, setPayslips] = useState([]);
  const [error, setError] = useState(null);
  const [filter, setFilter] = useState({
    month: currentMonth,
    year: currentYear,
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFilter((prev) => ({
      ...prev,
      [name]: value,
    }));
  };


  useEffect(() => {
    if (!COMPANY_ID || !filter.month || !filter.year)
      return setError(
        "Please select filter. If error persists, contact support.",
      );
    const fetchPayslips = async () => {
      setError(null);
      setPayslips([]);
      try {
        const res = await retrievePayrollByDate(
          TOKEN,
          COMPANY_ID,
          filter.month,
          filter.year,
        );
        setPayslips(res?.data);
      } catch (err) {
        setError(err.message);
        console.error("Failed to fetch employee payslips:", err);
      }
    };
    fetchPayslips();
  }, [TOKEN, COMPANY_ID, filter]);

  return (
    <Layout
      id={"summary"}
      title={"Summary"}
      // location={"summary"}
      // callToAction={`CREDIT BALANCE: ${company?.creditBalance ?? 0}`}
      // handleCallToActionClick={handleOpenCreditPurchaseModal}
    >
      <SummaryWrapper>
        <div className="heading-row">
          <H3>
            Report for {months[filter.month - 1]}, {filter.year}
          </H3>
        </div>
        <div className="form-and-errorbox">
          <form>
            <BaseFieldSet>
              <Label>Payment Year</Label>
              <BaseSelect
                name="year"
                onChange={(e) => handleChange(e)}
                value={filter.year}
              >
                {getYearRange(startDate, endDate).map((year, index) => {
                  return (
                    <option key={index} value={year}>
                      {year}
                    </option>
                  );
                })}
              </BaseSelect>
            </BaseFieldSet>
            <BaseFieldSet>
              <Label>Payment Month</Label>
              <BaseSelect
                name="month"
                onChange={(e) => handleChange(e, "payroll")}
                value={filter.month}
              >
                {months.map((month, index) => {
                  return (
                    <option key={index} value={index + 1}>
                      {month}
                    </option>
                  );
                })}
              </BaseSelect>
            </BaseFieldSet>
          </form>
          <div className="error-box">
            {error && <P style={{ color: "red" }}>{error}</P>}
          </div>
        </div>
        <div className="summary-table">
          <Table
            location={"Summary Table"}
            columnTitles={[
              "Employee",
              "Gross Pay",
              "Total Deduction",
              "Net Pay",
              "Action",
            ]}
            rowItems={payslips}
          />
        </div>
        {/* <PaymentModal /> */}
      </SummaryWrapper>
    </Layout>
  );
};
